export const LIKE = 'like';
export const DISLIKE = 'dislike';
export const CREATOR_LIKE = 'creator_like';
